<template>
    <article class="payment-complete-page">
        <FormHeader></FormHeader>
        <div class="mt-8">
            <SectionLabel>{{ title }}</SectionLabel>
        </div>
        <section class="content p-4">
            <div v-if="isProcessing" class="text-center">
                <div class="loading-spinner mb-4">
                    <div class="spinner"></div>
                </div>
                <p class="text-lg">決済処理を完了しています...</p>
                <p class="text-sm text-gray-500 mt-2">しばらくお待ちください</p>
            </div>
            <div v-else-if="error" class="text-center">
                <p class="text-red-500 text-lg mb-4">{{ errorMessage }}</p>
                <a href="/" class="link bg-[#282c8d] text-white px-6 py-2 rounded hover:bg-[#e9ee34] hover:text-[#676767]">
                    申込フォームに戻る
                </a>
            </div>
            <div v-else class="text-center">
                <p class="text-lg mb-4">決済が完了しました。</p>
                <p class="text-sm text-gray-600">完了ページに移動します...</p>
            </div>
        </section>
    </article>
</template>

<script>
import SectionLabel from "../../parts/app/SectionLabel.vue";
import FormHeader from "../../parts/app/FormHeader.vue";
import http from "../../http/app";
import { savePaymentError } from "../../utils/formDataCookie";

export default {
    name: "PaymentComplete",
    components: {SectionLabel, FormHeader},

    data() {
        return {
            isProcessing: true,
            error: false,
            errorMessage: '',
            title: '決済処理中'
        };
    },

    async mounted() {
        await this.completePayment();
    },

    methods: {
        async completePayment() {
            try {
                // URLパラメータから決済情報を取得
                const urlParams = new URLSearchParams(window.location.search);
                const paymentIntent = urlParams.get('payment_intent');
                const paymentIntentClientSecret = urlParams.get('payment_intent_client_secret');
                const redirectStatus = urlParams.get('redirect_status');

                // 必須パラメータの確認
                if (!paymentIntent) {
                    this.handleError('決済情報が見つかりません。申込フォームからやり直してください。');
                    return;
                }

                // リダイレクトステータスの確認
                if (redirectStatus === 'failed') {
                    this.handleErrorAndRedirect('3Dセキュア認証に失敗しました。別のカードでお試しください。');
                    return;
                }

                // 決済完了APIを呼び出し
                const response = await http.get('apply/complete', {
                    params: {
                        payment_intent: paymentIntent,
                        payment_intent_client_secret: paymentIntentClientSecret,
                        redirect_status: redirectStatus
                    }
                });
                if (response.data?.data?.success) {
                    this.title = '決済完了';
                    this.isProcessing = false;
                    
                    // 1秒後にサンクスページに遷移
                    setTimeout(() => {
                        this.$router.replace('/thank_you');
                    }, 1000);
                } else {
                    this.handleError('決済処理に失敗しました。お手数ですがお問い合わせください。');
                }

            } catch (error) {
                if (error.response?.status === 422) {
                    const errorData = error.response.data;
                    if (errorData.message === '3ds_failed') {
                        this.handleErrorAndRedirect('3Dセキュア認証に失敗しました。別のカードでお試しください。');
                    } else if (errorData.message === 'payment_failed') {
                        this.handleErrorAndRedirect(`決済に失敗しました。${errorData.error || ''}`);
                    } else {
                        this.handleErrorAndRedirect('決済に失敗しました。お手数ですがカード情報をご確認ください。');

                    }
                } else {
                    this.handleErrorAndRedirect('決済処理中に予期しないエラーが発生しました。');
                }
            }
        },

        handleError(message) {
            this.isProcessing = false;
            this.error = true;
            this.errorMessage = message;
            this.title = '';
        },
        
        handleErrorAndRedirect(message) {
            // エラーメッセージをCookieに保存
            savePaymentError(message);
            
            // フォーム入力画面にリダイレクト
            this.$router.replace('/');
        }
        
    }
}
</script>

<style scoped>
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #282c8d;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.link {
    display: inline-block;
    text-decoration: none;
}
</style>
